import { useEffect, useState } from "react";

export const DRAWER_TRANSITION_MS = 300;

/**
 * Drawer giriş/çıkış geçişi.
 *
 * İki şeyi birden çözer:
 * 1. Eleman `open` ile aynı commit'te açık pozisyonda doğarsa tarayıcının
 *    animasyonlayacağı bir başlangıç durumu olmaz ve "tak diye" açılır.
 *    Önce kapalı pozisyonda mount edip iki frame sonra `entered` veriyoruz.
 *    (Tek frame yetmiyor; ilk rAF hâlâ aynı boyama turunda olabiliyor.)
 * 2. Kapanış animasyonu bitene kadar DOM'da kalması gerekiyor.
 */
export default function useDrawerTransition(open) {
  const [mounted, setMounted] = useState(Boolean(open));
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      let inner = null;
      const outer = requestAnimationFrame(() => {
        inner = requestAnimationFrame(() => setEntered(true));
      });
      return () => {
        cancelAnimationFrame(outer);
        if (inner) cancelAnimationFrame(inner);
      };
    }
    setEntered(false);
    const timer = setTimeout(() => setMounted(false), DRAWER_TRANSITION_MS);
    return () => clearTimeout(timer);
  }, [open]);

  return { mounted, entered };
}
